module.exports = __webpack_public_path__ + "d31943171cfc89bdc77481a2d2ee2821.svg";